import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=a5a99184&"
import script from "./AssessmentForm.vue?vue&type=script&lang=js&"
export * from "./AssessmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports